export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29')
];

export const server_loads = [];

export const dictionary = {
		"/": [7],
		"/(cliente)/acervo": [19,[4]],
		"/(cliente)/acervo/[id]": [20,[4]],
		"/(backoffice)/admin": [14,[3]],
		"/(backoffice)/admin/livros": [15,[3]],
		"/(backoffice)/admin/livros/cadastrar": [16,[3]],
		"/(backoffice)/admin/livros/cadastrar/sucesso/[id]": [17,[3]],
		"/(backoffice)/admin/livros/editar/[id]": [18,[3]],
		"/(cliente)/biblioteca": [21,[4]],
		"/(cliente)/biblioteca/[id]": [22,[4]],
		"/(devolucao)/devolucao": [25,[5]],
		"/(docs)/docs": [27,[6]],
		"/(docs)/docs/[slug]": [28,[6]],
		"/(cliente)/historico": [23,[4]],
		"/(autenticacao)/login": [8,[2]],
		"/(autenticacao)/login/entrar": [9,[2]],
		"/(autenticacao)/login/primeiro-acesso": [10,[2]],
		"/(autenticacao)/login/verificar-email": [11,[2]],
		"/logout": [29],
		"/(cliente)/perfil": [24,[4]],
		"/(autenticacao)/redefinir-senha": [12,[2]],
		"/(autenticacao)/sso/[token]": [13,[2]],
		"/(devolucao)/tablet": [26,[5]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';